import SurveyPage from '../components/SurveyPage.js';
import ProgramInfo from '../components/dev/surveys/ProgramInfo';
import ResponseInfo from '../components/dev/surveys/ResponseInfo';
import QuestionInfo from '../components/dev/surveys/QuestionInfo';
import QuestionInfoButton from '../components/dev/surveys/QuestionInfoButton';
import intersection from 'lodash/intersection';
import MutuallyExclusive from '../directives/MutuallyExclusive';
import Hover from '../components/Hover.vue';
import { createApp } from 'vue';
import { mapMutations } from 'vuex';
import BootstrapVueNext from 'bootstrap-vue-next'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'


const el = document.getElementById('survey-page-instance');
if(el){
    const app = createApp({
        components: { 
            SurveyPage,
            ProgramInfo,
            ResponseInfo,
            QuestionInfo,
            QuestionInfoButton,
            Hover 
        },
        data() {
            return {
              showQuestionInfo: true,
              surveyQuestions: JSON.parse(el.getAttribute('survey-questions')),
              showConditions: JSON.parse(el.getAttribute('show-conditions')),
              program: JSON.parse(el.getAttribute('program')),
              response: JSON.parse(el.getAttribute('response')),
              showDevInfo: true,
              terms: JSON.parse(el.getAttribute('terms')),
              rawResponse: JSON.parse(el.getAttribute('raw-response')),
            };
        },
        methods: {
            updateResponseValue(questionName, visible) {
                this.surveyQuestions[questionName].variables.forEach(variable => {
                    if (!visible) {
                        this.response[variable.name] = null;
                    }
                })
            },
            showQuestion(questionName) {
                return this.meetsProgramConditions(questionName) 
                        && this.meetsResponseConditions(questionName) 
                        && this.meetsCustomConditions(questionName)
            },
            meetsProgramConditions(questionName) {
                const conditions = this.showConditions[questionName];
                if (Object.keys(conditions.program).length > 0) {
                    for (let attr in conditions.program) {
                        if (typeof this.program[attr] == 'object') {
                            if (intersection(this.program[attr], conditions.program[attr]).length == 0) {
                                return false;
                            }
                        }else if (conditions.program[attr].indexOf(this.program[attr]) == -1) {
                            return false;
                        }
                    }
                }
                return true;
            },
            meetsResponseConditions(questionName) {
                const conditions = this.showConditions[questionName];

                if (Object.keys(conditions.response).length > 0) {
                    for (let q in conditions.response) {                        
                        for (var i = 0; i < conditions.response[q].length; i++) {
                            if (this.response[q] == conditions.response[q][i]) {
                                return true;
                            }
                        }
                        return false;
                    }
                }
                return true;
            },
            meetsCustomConditions(questionName) {
                const conditions = this.showConditions[questionName];
                
                var ret = true;
                if (Object.keys(conditions.custom).length > 0) {
                    ret = eval( "("+conditions.custom +")" ).call(this);
                    if (ret === -1) {
                        ret = false;
                    }
                }
                
                return ret;
            }
        },
        computed: {
          questionVisibility: function () {
                let visibility = new Map();

                if(this.surveyQuestions) {
                    Object.keys(this.surveyQuestions).forEach((q) => {
                        const vis = this.showQuestion(q)
                        this.updateResponseValue(q, vis)
                        visibility.set(q, vis);
                    })
                }

                return visibility
          },
        }
    });
    app.directive('exclusive', MutuallyExclusive);

    app.use(BootstrapVueNext);
    app.mount('#survey-page-instance');
}